'use client';
import { useEffect, useRef } from 'react';

interface PublicHtmlIncludeProps {
  html: string;
}

export default function PublicHtmlInclude({ html }: PublicHtmlIncludeProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && html) {
      ref.current.innerHTML = html;
    }
  }, [html]);

  return <div data-component-id="src/components/PublicHtmlInclude.tsx:17:9" data-component-path="src/components/PublicHtmlInclude.tsx" data-component-line="17" data-component-end-line="17" data-component-file="PublicHtmlInclude.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D" ref={ref} />;
}
